module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid30_980x830.f385722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid30_980x830.jpg
// module id = 6g1M
// module chunks = 0